import Vue from 'vue';
import Router from 'vue-router';
import Welcome from '@/views/Welcome.vue';
import IdentityVerification from '@/views/IdentityVerification.vue';
import Identification from '@/views/Identification.vue';
import ContactInformation from '@/views/ContactInformation.vue';
import OtherInformation from '@/views/OtherInformation.vue';
import ChallengeQuestions from '@/views/ChallengeQuestions.vue';
import References from '@/views/References.vue';
import JointIdentification from '@/views/JointIdentification.vue';
import JointContactInformation from '@/views/JointContactInformation.vue';
import JointOtherInformation from '@/views/JointOtherInformation.vue';
import JointReferences from '@/views/JointReferences.vue';
import Review from '@/views/Review.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome,
      meta: { gtm: 'Welcome' }
    },
    {
      path: '/verification',
      name: 'verification',
      component: IdentityVerification
    },
    {
      path: '/identification',
      name: 'identification',
      component: Identification,
      meta: { gtm: 'Primary Identification' }
    },
    {
      path: '/contactinformation',
      name: 'contactinformation',
      component: ContactInformation,
      meta: { gtm: 'Primary Contact Information' }
    },
    {
      path: '/otherinformation',
      name: 'otherInformation',
      component: OtherInformation,
      meta: { gtm: 'Primary Additional Information' }
    },
    {
      path: '/challengequestions',
      name: 'challengequestions',
      component: ChallengeQuestions,
      props: true
    },
    {
      path: '/references',
      name: 'references',
      component: References,
      meta: { gtm: 'Primary References' }
    },
    {
      path: '/jointidentification',
      name: 'jointIdentification',
      component: JointIdentification,
      meta: { gtm: 'Joint Identification' }
    },
    {
      path: '/jointcontactinformation',
      name: 'jointcontactinformation',
      component: JointContactInformation,
      meta: { gtm: 'Joint Contact Information' }
    },
    {
      path: '/jointotherinformation',
      name: 'jointotherInformation',
      component: JointOtherInformation,
      meta: { gtm: 'Joint Additional Information' }
    },
    {
      path: '/jointreferences',
      name: 'jointreferences',
      component: JointReferences,
      meta: { gtm: 'Joint References' }
    },
    {
      path: '/review',
      name: 'review',
      component: Review,
      meta: { gtm: 'Application Review' }
    },
  ],
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

export default router;
